module.exports = __webpack_public_path__ + "mj_andr_qr.cab1213.png";